import { render, staticRenderFns } from "./PaymentCardBaseBlock.vue?vue&type=template&id=fa2aaaaa&scoped=true"
import script from "./PaymentCardBaseBlock.vue?vue&type=script&lang=js"
export * from "./PaymentCardBaseBlock.vue?vue&type=script&lang=js"
import style0 from "./PaymentCardBaseBlock.vue?vue&type=style&index=0&id=fa2aaaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2aaaaa",
  null
  
)

export default component.exports